//consolidate all livefeed imports/exports to one file
import * as livefeedRedux from "./LiveFeed/redux";

export { default as livefeedservice } from "./LiveFeed/livefeed";
export { Point, ProcessPoints, ProcessorArg, ProcessorRtn } from "./types";
export { livefeedRedux };



// WEBPACK FOOTER //
// ./src/services/Live/index.js